module.exports = __webpack_public_path__ + "static/media/about 325-177.d75c454f.jpg";